import axios from "axios";

export const GET_CONVERSATION_MODEL = "GET_CONVERSATION_MODEL";
export const CLEAR_CONVERSATION_MODEL = "CLEAR_CONVERSATION_MODEL";
export const CREATE_CONVERSATION = "CREATE_CONVERSATION";
export const GET_CONVERSATIONS = "GET_CONVERSATIONS";
export const CLOSE_CONVERSATION = "CLOSE_CONVERSATION";
export const GET_CONVERSATION_DETAIL = "GET_CONVERSATION_DETAIL";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const REOPEN_CONVERSATION = "REOPEN_CONVERSATION";
export const MARK_CONVERSATION_AS_READ = "MARK_CONVERSATION_AS_READ";
export const GLOBAL_SEARCH_CONVERSATIONS = "GLOBAL_SEARCH_CONVERSATIONS";
export const CLEAN_GLOBAL_SEARCH_CONVERSATIONS = "CLEAN_GLOBAL_SEARCH_CONVERSATIONS";
export const GET_MESSAGING_ACCIDENTS = "GET_MESSAGING_ACCIDENTS";
export const CLEAN_MESSAGING_ACCIDENTS = "CLEAN_MESSAGING_ACCIDENTS";
export const GET_PENDING_MESSAGING_COUNT = "GET_PENDING_MESSAGING_COUNT";
export const DECREMENT_PENDING_MESSAGING_COUNT = "DECREMENT_PENDING_MESSAGING_COUNT";
export const decrementPendingMessagingCount = (amount) => ({ type: DECREMENT_PENDING_MESSAGING_COUNT, payload: amount });

export const SHOULD_SHOW_PENDING_MESSAGE_ALERT = "SHOULD_SHOW_PENDING_MESSAGE_ALERT";
export const shouldShowPendingMessageAlert = (idArt) => (dispatch) => {
  return dispatch({
    type: SHOULD_SHOW_PENDING_MESSAGE_ALERT,
    payload: axios
      .get(`messaging/shouldShowPendingMessageAlert?idArt=${idArt}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error)),
  });
};

export const getPendingMessagingCount = (idPrestador) => (dispatch) => {
  return dispatch({
    type: GET_PENDING_MESSAGING_COUNT,
    payload: axios
      .get(`messaging/pendingCount?idPrestador=${idPrestador}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error)),
  });
};

export const getConversationModel = (wriId = null, providerId = null) => (dispatch) => {
  let query = "";
  if (wriId && providerId) query = `?wriId=${wriId}&providerId=${providerId}`;
  else if (wriId) query = `?wriId=${wriId}`;
  else if (providerId) query = `?providerId=${providerId}`;

  return dispatch({
    type: GET_CONVERSATION_MODEL,
    payload: axios
      .get(`messaging/conversation/model${query}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const clearConversationModel = () => ({
  type: CLEAR_CONVERSATION_MODEL,
});

export const createConversation = (body) => (dispatch) => {
  return dispatch({
    type: CREATE_CONVERSATION,
    payload: axios
      .post("messaging/conversation", body)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error)),
  });
};

export const getConversations = (idSiniestro, wriId, providerId) => (dispatch) => {
  return dispatch({
    type: GET_CONVERSATIONS,
    payload: axios
      .get(`messaging/conversations/${idSiniestro}?wriId=${wriId}` + (providerId ? `&providerId=${providerId}` : ""))
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const closeConversation = (idConversacion, idArt, idTipo, idSubtipo) => (dispatch) => {
  return dispatch({
    type: CLOSE_CONVERSATION,
    payload: axios
      .put(`messaging/conversations/${idConversacion}/close?idArt=${idArt}&idTipo=${idTipo}&idSubtipo=${idSubtipo}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error)),
  });
};

export const getConversationDetail = (idConversacion, idArt, idSubtipo) => (dispatch) => {
  return dispatch({
    type: GET_CONVERSATION_DETAIL,
    payload: axios
      .get(`messaging/conversations/${idConversacion}/detail?idArt=${idArt}&idSubtipo=${idSubtipo}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const sendMessage = (idConversacion, mensaje, idMensajeOrigen, idArt, idSubtipo) => (dispatch) => {
  return dispatch({
    type: SEND_MESSAGE,
    payload: axios
      .post(`messaging/conversations/${idConversacion}/messages?idArt=${idArt}&idSubtipo=${idSubtipo}`, {
        Mensaje: mensaje,
        IdMensajeOrigen: idMensajeOrigen
      })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error)),
  });
};

export const reopenConversation = (idConversacion, mensaje, idArt, idTipo, idSubtipo) => (dispatch) => {
  return dispatch({
    type: REOPEN_CONVERSATION,
    payload: axios
      .put(`messaging/conversations/${idConversacion}/reopen?idArt=${idArt}&idTipo=${idTipo}&idSubtipo=${idSubtipo}`, {
        Mensaje: mensaje
      })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error)),
  });
};

export const markConversationAsRead = (idConversacion, idArt, idSubtipo) => (dispatch) => {
  return dispatch({
    type: MARK_CONVERSATION_AS_READ,
    payload: axios
      .put(`messaging/conversations/${idConversacion}/read?idArt=${idArt}&idSubtipo=${idSubtipo}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error)),
  });
};

export const globalSearchConversations = (body) => (dispatch) => {
  return dispatch({
    type: GLOBAL_SEARCH_CONVERSATIONS,
    payload: axios
      .post("messaging/globalSearch", body)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const cleanGlobalSearchConversations = () => ({
  type: CLEAN_GLOBAL_SEARCH_CONVERSATIONS,
});

export const getMessagingAccidents = (idArt, providerId) => (dispatch) => {
  return dispatch({
    type: GET_MESSAGING_ACCIDENTS,
    payload: axios
      .get(`messaging/arts/${idArt}/accidents?providerId=${providerId}`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const cleanMessagingAccidents = () => ({
  type: CLEAN_MESSAGING_ACCIDENTS,
});
